import React, { useState } from 'react';
import styles from "../../styles/service/Documan.module.css";

import patent from "../../assets/documan/특허출원1페이지.png";
import tta1 from "../../assets/documan/TTA공인평가인증 시험평가서1.png";
import tta2 from "../../assets/documan/TTA공인평가인증 시험평가서2.png";
import documanIntro from "../../videos/documan-intro.mp4";

const Documan = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleToggleVideo = () => {
    setShowVideo((prev) => !prev);
  };

  return (
    <section className={styles.hero}>
      <div className={styles.bgOverlay} />

      <div className={styles.content}>

        {/* 제목 */}
        <header className={styles.header}>
          <h1 className={styles.title}>AI.DocuMan</h1>
          <p className={styles.subtitle}>
            RAG 기반 차세대 문서관리·검색 엔진
          </p>
        </header>

        {/* 설명 카드 */}
        <div className={styles.panel}>
          <p className={styles.text}>
            전통적인 검색시스템은 키워드의 빈도와 위치를 기반으로 관련성을 평가하기 때문에
            문장의 구조나 맥락을 이해하지 못해 사용자의 질문이나 의도를 정확히 파악하기
            어렵습니다. 반면에 LLM(Large Language Model)을 사용한 검색은 자연어 이해 능력이
            뛰어나 질문의 의미를 파악하고 문맥에 맞는 결과를 제공할 수 있습니다.
          </p>

          <p className={styles.text}>
            근래에는 제한된 문서들을 대상으로 LLM을 적용하는
            RAG(Retrieval Augmented Generation) 방식의 검색시스템 사용이 확대되고 있습니다.
            RAG 방식은 여러 면에서 효과적이지만, 검색 데이터의 품질에 크게 의존하기 때문에
            데이터의 품질을 높이는 다양한 방식에 대한 연구가 필요합니다.
          </p>

          <p className={styles.text}>
            ㈜메타에이아이는 자연어 형태의 질의를 하고 해당 문서에서 적합한 내용을 찾아 통합하여 
            결과를 알려주는 RAG 기반의 문서관리 엔진을 개발하는 연구 과제(중소벤처기업부)를 통해 
            특허출원(출원번호 : 10-2025-0088069)을 받고 ‘AI.DocuMan’으로 공인시험성적평가(TTA)를 
            수행하여 우수한 성능과 만족도 평가를 받았습니다. RAG의 성능을 향상시키기 위해 LLM에 
            제공되는 검색 데이터의 품질을 높이는 자체 개발한 알고리즘을 사용하였으며, 
            기존 시스템과 비교하여 다음과 같은 특징이 있습니다.
          </p>

          {/* 특징 */}
          <ul className={styles.featureList}>
            <li>
              문서의 목차정보와 내용을 바탕으로 메타데이터를 구축하여 RAG 기반의 검색을 할 때 
              LLM에 제공되는 검색데이터의 품질을 높임으로써 검색엔진의 성능을 향상
            </li>
            <li>
              다양한 외부 생성형 인공지능 모델(ChatGPT, Gemini 등)을 선택할 수 있으며 
              사용자 질의에 대한 답변의 근거 자료(답변 생성의 근거)를 제공하여(예: 문서 및 페이지 등)
              답변의 신뢰성을 높임
            </li>
          </ul>

          {/* 버튼 */}
          <div className={styles.buttonRow}>
            <button 
              className={styles.outlineBtn}
              onClick={handleToggleVideo}
              aria-expanded={showVideo}
              aria-controls="documan-intro-video"
            >
              {showVideo ? "소개영상 닫기" : "AI.DocuMan 소개영상"}
            </button>

            <a
              className={styles.primaryBtn}
              href="https://112.218.51.42:8000/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AI.DocuMan 서비스 체험하기
            </a>
          </div>

          {/* 소개영상 영역 (버튼 누르면 아래 공간 생기면서 표시) */}
          <div id="documan-intro-video" className={`${styles.videoWrap} ${showVideo ? styles.videoOpen : ""}`}>
            <div className={styles.videoInner}>
              <div className={styles.videoRatio}>
                <video controls playsInline>
                  <source src={documanIntro} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>

        {/* 증빙 이미지 */}
        <section className={styles.proofSection}>
          <div className={styles.proofGrid}>
            {/* 특허 */}
            <figure className={styles.proofFigure}>
              <div className={styles.slot}>
                <img src={patent} alt="특허출원 1페이지" />
              </div>
              <figcaption className={styles.caption}>특허출원 1페이지</figcaption>
            </figure>

            {/* TTA 2장 묶음 */}
            <figure className={styles.proofFigure}>
              <div className={`${styles.twoSlots}`}>
                <div className={styles.slot}>
                  <img src={tta1} alt="TTA 공인평가인증 시험평가서 1" />
                </div>
                <div className={styles.slot}>
                  <img src={tta2} alt="TTA 공인평가인증 시험평가서 2" />
                </div>
              </div>
              <figcaption className={styles.caption}>
                TTA공인평가인증 시험평가서 1페이지
              </figcaption>
            </figure>
          </div>
        </section>
      </div>
    </section>
  )
}

export default Documan